import React from 'react';

const PlaneIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.4274 0.578299C18.9274 0.0672987 18.1874 -0.121701 17.4974 0.0782986L1.40742 4.7273C0.67942 4.9293 0.16342 5.5063 0.0244202 6.2383C-0.11758 6.9843 0.37842 7.9323 1.02642 8.3283L6.05742 11.4003C6.57342 11.7163 7.23942 11.6373 7.66642 11.2093L13.4274 5.4483C13.7174 5.1473 14.1974 5.1473 14.4874 5.4483C14.7774 5.7373 14.7774 6.2083 14.4874 6.5083L8.71642 12.2693C8.28842 12.6973 8.20842 13.3613 8.52342 13.8783L11.5974 18.9283C11.9574 19.5273 12.5774 19.8683 13.2574 19.8683C13.3374 19.8683 13.4274 19.8683 13.5074 19.8573C14.2874 19.7583 14.9074 19.2273 15.1374 18.4773L19.9074 2.5083C20.1174 1.8283 19.9274 1.0883 19.4274 0.578299Z'
        fill='currentColor'
      />
      <path
        opacity='0.4'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.01049 14.8079C0.818492 14.8079 0.626492 14.7349 0.480492 14.5879C0.187492 14.2949 0.187492 13.8209 0.480492 13.5279L1.84549 12.1619C2.13849 11.8699 2.61349 11.8699 2.90649 12.1619C3.19849 12.4549 3.19849 12.9299 2.90649 13.2229L1.54049 14.5879C1.39449 14.7349 1.20249 14.8079 1.01049 14.8079ZM4.77169 16.0003C4.57969 16.0003 4.38769 15.9273 4.24169 15.7803C3.94869 15.4873 3.94869 15.0133 4.24169 14.7203L5.60669 13.3543C5.89969 13.0623 6.37469 13.0623 6.66769 13.3543C6.95969 13.6473 6.95969 14.1223 6.66769 14.4153L5.30169 15.7803C5.15569 15.9273 4.96369 16.0003 4.77169 16.0003ZM5.02539 19.5683C5.17139 19.7153 5.36339 19.7883 5.55539 19.7883C5.74739 19.7883 5.93939 19.7153 6.08539 19.5683L7.45139 18.2033C7.74339 17.9103 7.74339 17.4353 7.45139 17.1423C7.15839 16.8503 6.68339 16.8503 6.39039 17.1423L5.02539 18.5083C4.73239 18.8013 4.73239 19.2753 5.02539 19.5683Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default PlaneIcon;
